import { render, staticRenderFns } from "./latestNews.vue?vue&type=template&id=31a6f836&scoped=true&"
import script from "./latestNews.vue?vue&type=script&lang=js&"
export * from "./latestNews.vue?vue&type=script&lang=js&"
import style0 from "./latestNews.vue?vue&type=style&index=0&id=31a6f836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a6f836",
  null
  
)

export default component.exports